import { render, staticRenderFns } from "./IceMap.vue?vue&type=template&id=39097b94"
import script from "./IceMap.vue?vue&type=script&lang=js"
export * from "./IceMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports